import { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import { useBetween } from 'use-between';
import { safeJsonParse } from '../../utils/utils';
import { calculateExpirationDate } from '../utils';


// import { CollectionListTracker } from '../../utils/collectionListTracker';

const quoteState = () => {
  const [items, setItems] = useState(itemsFromStorage());
  // const [totalPrice, setTotalPrice] = useState(0);
  // const [totalSavings, setTotalSavings] = useState(0);
  // const [totalCompare, setTotalCompare] = useState(0);
  // const [totalQuantity, setTotalQuantity] = useState(0);
  const [showMiniQuote, setShowMiniQuote] = useState(false);
  // const [quoteId, setQuoteId] = useState();

  const [expirationDate, setExpirationDate] = useState(calculateExpirationDate(new Date()));
  // const [expirationDate, setExpirationDate] = useMemo(() => calculateExpirationDate(new Date()), []);

  const persistTimerRef = useRef(null);
  


  // useEffect(() => {
  //   console.log("ShowMiniQuote: ", showMiniQuote);
  // }, [showMiniQuote]);

  function itemsFromStorage() { 
    let storageItems = []
    if (localStorage.getItem("quoteItems")) {
      const storageData = safeJsonParse(localStorage.getItem("quoteItems"));
      if (Array.isArray(storageData)) storageItems = storageData;
    };
    return storageItems;
  }

  const setConvertCartItems = useCallback(
    (items) => {
      setItems((items));
    },
  [setItems]
  );

  const addItem = useCallback(
    (item) => {
      setItems((items) => items.concat(item));
      // window.dispatchEvent(new CustomEvent('quote:item:added', {
      //   bubbles: true,
      //   detail: {
      //     variant: item,
      //     quantity: parseInt(document.querySelector('[name="quantity"]').value)
      //   }
      // }));
      setShowMiniQuote(true);
    },
    [setItems],
  );

  
  const updateItem = useCallback(
    (item, values) => { 
      if ((typeof values.quantity !== 'undefined') && (values.quantity === 0)) {
        setItems((items) => items.filter((v) => v !== item))
      } else {
        if (typeof values.quantity !== 'undefined' && !Number.isInteger(values.quantity)) {
          delete values.quantity;
        }
        setItems((items) =>
          items.map((i) => ({
            ...i,
            ...(i === item ? values : {})
          }))
        )
      }},
    [setItems]
  );

  
  
  useEffect(() => {
    // if (!localStorage.getItem("quoteId")) localStorage.setItem("quoteId", crypto.randomUUID());
    if (!localStorage.getItem("quoteId")) localStorage.setItem("quoteId", Date.now());
    // const handleStorageChange = () => setItems(itemsFromStorage());
    
    const handleStorageChange = (e) => {
      // Only update if the change is from a different tab/window and specifically for quoteItems
      if (e.key === "quoteItems" && e.newValue !== e.oldValue) {
        setItems(itemsFromStorage());
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);


  // useEffect(() => {
  //   localStorage.setItem("quoteItems", JSON.stringify(items));
  //   let price = 0, compare = 0, savings = 0, quantity = 0;
  //   for (const item of items) {
  //     price += item.price * item.quantity;
  //     compare += item.compareAtPrice * item.quantity;
  //     savings += item.compareAtPrice ? (item.compareAtPrice - item.price) * item.quantity : 0;
  //     quantity += item.quantity;
  //   }
  //   setTotalPrice(price);
  //   setTotalCompare(compare);
  //   setTotalSavings(savings);
  //   setTotalQuantity(quantity);
    
  //   window.$totalPrice = price / 100;
  // }, [items]);

  const totalPrice    = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const totalCompare  = useMemo(() => items.reduce((s, i) => s + i.compareAtPrice * i.quantity, 0), [items]);
  const totalSavings  = useMemo(() => items.reduce((s, i) => s + (i.compareAtPrice ? (i.compareAtPrice - i.price) * i.quantity : 0), 0), [items]);
  const totalQuantity = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  useEffect(() => {
    if (persistTimerRef.current) clearTimeout(persistTimerRef.current);
    persistTimerRef.current = setTimeout(() => {
      localStorage.setItem("quoteItems", JSON.stringify(items));
      window.$totalPrice = totalPrice / 100;
    }, 250);

    return () => {
      if (persistTimerRef.current) clearTimeout(persistTimerRef.current);
    };
  }, [items, totalPrice]);
  
    
  return {
    items,
    totalPrice,
    totalQuantity,
    totalCompare,
    totalSavings,
    addItem,
    updateItem,
    showMiniQuote,
    setShowMiniQuote,
    setConvertCartItems,
    expirationDate,
  };
};

export const useQuoteState = () => useBetween(quoteState);
